import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-018c0df2")

_pushScopeId("data-v-018c0df2")
const _hoisted_1 = { class: "flex flex-col gap-y-4 relative p-4 font-montserrat min-h-0" }
const _hoisted_2 = {
  key: 0,
  "data-testid": "pickup-stt-list-modal-error",
  class: "p-8 text-center text-red-lp-100 font-medium"
}
const _hoisted_3 = {
  key: 1,
  class: "overflow-auto",
  "data-testid": "pickup-stt-list-modal-table"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
      title: 
      _ctx.$t('pickupV2.modalSttPickupList.titleAwb', {
        bkdCount: _ctx.selectedAwbCount
      })
    ,
      persistent: "",
      customBody: "p-0",
      customWidth: "custom-dhl-dialog-width",
      customHeight: "534px",
      showOverflow: true,
      "data-testid": "pickup-stt-list-modal",
      closeButtonTestId: "pickup-stt-list-modal-button-close"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Search, {
            onInput: _ctx.onSearch,
            onClear: () => _ctx.onSearch(''),
            value: _ctx.searchQuery,
            placeholder: _ctx.$t('pickupV2.modalSttPickupList.searchPlaceholder'),
            class: "w-300px",
            "data-testid": "pickup-stt-list-modal-input-search"
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
          (_ctx.fetchError)
            ? (_openBlock(), _createBlock("div", _hoisted_2, " Gagal mengambil data STT. Silakan coba lagi. "))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_TableV2, {
                  ref: "tableV2",
                  columns: _ctx.columns,
                  data: _ctx.filteredItems,
                  isEmpty: _ctx.isErrorList,
                  iconEmpty: _ctx.isEmpty ? '' : 'ill_spot_search',
                  emptyHeaderMessage: 
            _ctx.isEmpty
              ? _ctx.$t('pickupV2.modalSttPickupList.empty.title')
              : _ctx.$t('pickupV2.modalSttPickupList.notFound.title')
          ,
                  emptyMessage: 
            _ctx.isEmpty
              ? _ctx.$t('pickupV2.modalSttPickupList.empty.message')
              : _ctx.$t('pickupV2.modalSttPickupList.notFound.message')
          ,
                  loading: _ctx.isLoadingLoop,
                  isCheckBox: true,
                  isDownloadCheckBox: false,
                  checkedData: _ctx.selectedItems,
                  "onUpdate:checkedData": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedItems = $event)),
                  isSpaceTop: false,
                  borderTop: false,
                  isDetailAble: false,
                  bgHeader: "bg-white",
                  isBorderOnHeadBgWhite: "",
                  isPinnedScrollBottom: "",
                  pinnedSubstractHeight: "400px",
                  paginationStyle: "none"
                }, null, 8, ["columns", "data", "isEmpty", "iconEmpty", "emptyHeaderMessage", "emptyMessage", "loading", "checkedData"])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.notification = $event)),
      isCustom: "",
      message: _ctx.copyStyles.message,
      customStyles: _ctx.copyStyles,
      isAutoDisplay: false,
      isAutoClose: "",
      timeout: 3,
      class: _ctx.copyStyles.width,
      showIconClose: false
    }, null, 8, ["modelValue", "message", "customStyles", "class"])
  ], 64))
})